"use client";

// src/kbd.tsx
import { cn } from "@momo/utils";
import { jsx, jsxs } from "react/jsx-runtime";
var kbdKeysMap = {
  command: "\u2318",
  shift: "\u21E7",
  ctrl: "\u2303",
  option: "\u2325",
  enter: "\u21B5",
  delete: "\u232B",
  escape: "\u238B",
  tab: "\u21E5",
  capsLock: "\u21EA",
  up: "\u2191",
  right: "\u2192",
  down: "\u2193",
  left: "\u2190",
  pageup: "\u21DE",
  pagedown: "\u21DF",
  home: "\u2196",
  end: "\u2198",
  help: "?",
  space: "\u2423"
};
var kbdKeysLabelMap = {
  command: "Command",
  shift: "Shift",
  ctrl: "Control",
  option: "Option",
  enter: "Enter",
  delete: "Delete",
  escape: "Escape",
  tab: "Tab",
  capsLock: "Caps Lock",
  up: "Up",
  right: "Right",
  down: "Down",
  left: "Left",
  pageup: "Page Up",
  pagedown: "Page Down",
  home: "Home",
  end: "End",
  help: "Help",
  space: "Space"
};
var Kbd = (props) => {
  const { children, keys, className, ...rest } = props;
  return /* @__PURE__ */ jsxs(
    "kbd",
    {
      className: cn(
        "bg-muted inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 font-mono text-sm shadow-sm",
        className
      ),
      ...rest,
      children: [
        keys?.map((key) => /* @__PURE__ */ jsx("abbr", { title: kbdKeysLabelMap[key], className: "no-underline", children: kbdKeysMap[key] }, key)),
        children
      ]
    }
  );
};

export {
  Kbd
};
